<template>
<div>
  <Grid name="filterGridClient" ref="filterGridClient" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import kendo from '@progress/kendo-ui/js/kendo.all.js'
export default {
  name: 'Client',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'clients',
      columns: [{
        'title': '',
        width: '100px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '100px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'codle',
        title: 'Código LE'
      }, {
        width: '120px',
        field: 'nif',
        title: 'NIF'
      }, {
        width: '160px',
        field: 'name',
        title: 'Nome'
      }, {
        field: 'commercial_designation',
        title: 'Designação Comercial',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    addIncludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridClient.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'client_id',
        item: dataItem,
        title: 'Client',
        'type': 'includes'
      })
    },
    addExcludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridClient.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'client_id',
        item: dataItem,
        title: 'Client',
        'type': 'excludes'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ClientFilter.vue?610df7a2